/** Amplitude identity cookies shared with the lobby (launcher parity). */
export const AMPLITUDE_COOKIES = {
  AMPLITUDE_ID: 'amplitude-id',
  AMP_SESSION_ID: 'amp_session_id',
  AMP_DEVICE_ID: 'amp_device_id',
} as const;

const DEVICE_ID_COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

export const getAmplitudeCookieValue = (
  cookieName: string,
  decode = true,
): string => {
  if (typeof document === 'undefined') return '';
  const cookie = (document.cookie || '')
    .split(';')
    .map((item) => item.trim())
    .find((item) => cookieName === item.split('=')[0]);
  if (!cookie) return '';
  const cValue = cookie.split('=').slice(1).join('=').trim() || '';
  return decode ? decodeURIComponent(cValue) : cValue;
};

export const setAmplitudeDeviceIdCookie = (
  deviceId: string,
  rootDomain?: string,
): void => {
  if (typeof document === 'undefined') return;
  const domain = rootDomain ? `; domain=.${rootDomain}` : '';
  document.cookie = `${AMPLITUDE_COOKIES.AMP_DEVICE_ID}=${encodeURIComponent(deviceId)}; path=/${domain}; max-age=${DEVICE_ID_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`;
};
